import ApiClient from './apiClient'
import {
  TeamCondition,
  DailySearchCondition,
  TeamReportWorkingTime,
  TeamReportLineChart,
  TeamReportHeatMap,
  MonthlySearchCondition,
  TeamReportWorkDetail,
  CustomSearchCondition,
  TeamReportTimeLine,
} from '../types/team'

import {
  UserData,
  DataExists,
} from '../types/report'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getReportExists = async (params: TeamCondition): Promise<any> => ApiClient.get(
  '/api/v2/renderer/team_report/daily/exists',
  (response: DataExists) => response,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getWorkingTime = async (params: DailySearchCondition): Promise<any> => ApiClient.get(
  '/api/v1/renderer/team_report/daily/worktime',
  (response: TeamReportWorkingTime) => response,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getUserData = async (params: DailySearchCondition): Promise<any> => ApiClient.get(
  '/api/v1/renderer/team_report/daily/userdata',
  (response: UserData[]) => response,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getLineChart = async (params: DailySearchCondition): Promise<any> => ApiClient.get(
  '/api/v1/renderer/team_report/daily/linechart',
  (response: TeamReportLineChart) => response,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getWorkDetail = async (params: DailySearchCondition): Promise<any> => ApiClient.get(
  '/api/v1/renderer/team_report/daily/workdetail',
  (response: TeamReportWorkDetail) => response,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getTimeLine = async (params: DailySearchCondition): Promise<any> => ApiClient.get(
  '/api/v1/renderer/team_report/daily/timeline',
  (response: TeamReportTimeLine) => response,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getMonthlyReportExists = async (params: TeamCondition): Promise<any> => ApiClient.get(
  '/api/v2/renderer/team_report/monthly/exists',
  (response: DataExists) => response,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getMonthlyWorkingTime = async (params: MonthlySearchCondition): Promise<any> => ApiClient.get(
  '/api/v1/renderer/team_report/monthly/worktime',
  (response: TeamReportWorkingTime) => response,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getMonthlyUserData = async (params: MonthlySearchCondition): Promise<any> => ApiClient.get(
  '/api/v1/renderer/team_report/monthly/userdata',
  (response: UserData[]) => response,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getMonthlyLineChart = async (params: MonthlySearchCondition): Promise<any> => ApiClient.get(
  '/api/v1/renderer/team_report/monthly/linechart',
  (response: TeamReportLineChart) => response,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getMonthlyHeatMap = async (params: MonthlySearchCondition): Promise<any> => ApiClient.get(
  '/api/v1/renderer/team_report/monthly/heatmap',
  (response: TeamReportHeatMap) => response,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getMonthlyWorkDetail = async (params: MonthlySearchCondition): Promise<any> => ApiClient.get(
  '/api/v2/renderer/team_report/monthly/workdetail',
  (response: TeamReportWorkDetail) => response,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getMonthlyTimeLine = async (params: MonthlySearchCondition): Promise<any> => ApiClient.get(
  '/api/v1/renderer/team_report/monthly/timeline',
  (response: TeamReportTimeLine) => response,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getCustomReportExists = async (params: TeamCondition): Promise<any> => ApiClient.get(
  '/api/v1/renderer/team_report/range/exists',
  (response: DataExists) => response,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getCustomWorkingTime = async (params: CustomSearchCondition): Promise<any> => ApiClient.get(
  '/api/v1/renderer/team_report/range/worktime',
  (response: TeamReportWorkingTime) => response,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getCustomUserData = async (params: CustomSearchCondition): Promise<any> => ApiClient.get(
  '/api/v1/renderer/team_report/range/userdata',
  (response: UserData[]) => response,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getCustomLineChart = async (params: CustomSearchCondition): Promise<any> => ApiClient.get(
  '/api/v1/renderer/team_report/range/linechart',
  (response: TeamReportLineChart) => response,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getCustomHeatMap = async (params: CustomSearchCondition): Promise<any> => ApiClient.get(
  '/api/v1/renderer/team_report/range/heatmap',
  (response: TeamReportHeatMap) => response,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getCustomWorkDetail = async (params: CustomSearchCondition): Promise<any> => ApiClient.get(
  '/api/v1/renderer/team_report/range/workdetail',
  (response: TeamReportWorkDetail) => response,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getCustomTimeLine = async (params: CustomSearchCondition): Promise<any> => ApiClient.get(
  '/api/v1/renderer/team_report/range/timeline',
  (response: TeamReportTimeLine) => response,
  params,
)
